import dayjs from 'dayjs';
import { Day, Month, CalendarEvent } from './common-types';

/*
 * Common format to use for date comparisons and state
 */
export const DATE_FORMAT = 'YYYY-MM-DD';
export const UI_MONTH_FORMAT = 'MMM YYYY';
export const UI_DAY_FORMAT = 'MMMM D';

export const getWeekdays = (format?: string) => {
    const weekdays = [];
    format = format || 'ddd';
    for (let i = 0; i < 7; i++) {
        weekdays.push(dayjs().day(i).format(format));
    }
    return weekdays;
}

/*
 * Append dates to the beginning and end of the day array as needed to fill up the grid
 */
export const fillWeeksForGrid = (dayArray: Day[]) => {
    const firstDayData = dayjs(dayArray[0].date);
    const lastDayData = firstDayData.endOf('month');
    let leadingDays = [];
    let trailingDays = [];
    // If first day of the month isn't Sunday (dependent on locale)
    if (firstDayData.day() !== 0) {
        // backtrack through dates until you reach Sunday
        let offset = 1;
        for (let i = firstDayData.day() - 1; i > -1; i--) {
            leadingDays.unshift({ date: firstDayData.subtract(offset, 'day').format(DATE_FORMAT), events: [] });
            offset += 1;
        }
    }

    // Opposite process from first day
    if (lastDayData.day() !== 6) {
        let offset = 1;
        for (let i = lastDayData.day() + 1; i < 7; i++) {
            trailingDays.push({ date: lastDayData.add(offset, 'day').format(DATE_FORMAT), events: [] });
            offset += 1;
        }
    }

    return [...leadingDays, ...dayArray, ...trailingDays];
}

export const getMonthsInRange = (startDate: string, endDate: string) => {
    let months: Month[] = [];
    let start = dayjs(startDate).startOf('month');
    let end = dayjs(endDate).endOf('month');
    for (let i = start; i.isBefore(end); i = i.add(1, 'month')) {
        months.push({ month: i.format(DATE_FORMAT), days: [] });
    }
    return months;
}

export const getDaysInMonth = (monthDate: string) => {
    let days: Day[] = [];
    let start = dayjs(monthDate).startOf('month').startOf('day');
    let end = dayjs(monthDate).endOf('month').endOf('day');
    for (let i = start; i.isBefore(end); i = i.add(1, 'day')) {
        days.push({ date: i.format(DATE_FORMAT), events: [] });
    }
    return days;
}

export const sortEventsChronologically = (events: CalendarEvent[]) => {
    return events.sort((a, b) => dayjs(a.eventDate).diff(dayjs(b.eventDate)));
}

export const getDateModifiers = (day: Day, today: string, currentDate: string, currentMonth: string, prefix: string) => {
    let modifiers = [];
    const dateData = dayjs(day.date);
    if (today == dateData.format(DATE_FORMAT)) {
        modifiers.push(`${prefix}today`);
    }
    if (currentDate == dateData.format(DATE_FORMAT)) {
        modifiers.push(`${prefix}active`);
    }
    if (day.events.length < 1) {
        modifiers.push(`${prefix}inactive`);
    }
    if (dayjs().startOf('day').isAfter(dateData)) {
        modifiers.push(`${prefix}past`);
    }
    if (dateData.month() !== dayjs(currentMonth).month()) {
        modifiers.push(`${prefix}outside-month`);
    }
    return modifiers.join(' ');
}

export const isInView = (element: Element) => {
    const bounds = element.getBoundingClientRect();
    const pageHeight = window.innerHeight;
    return bounds.top < pageHeight && bounds.top > 0;
}